import { get, post, put, delete_ } from ".";

const ACTIVE_AREA_KEY = "activeAreaId";
const ACTIVE_AREA_DATE_KEY = "activeAreaIdDate";

export const getAllRegions = () => {
  return get(`/api/region/manage/myCartableAreas`, true);
};
export const getAllUserDigestArea = () => {
  return get(`/api/region/manage_user/digestList`, true);
};
export const getActiveAreaId = async () => {
  const storedAreaId = localStorage.getItem(ACTIVE_AREA_KEY);
  const storedDate = localStorage.getItem(ACTIVE_AREA_DATE_KEY);

  const today = new Date().toDateString();

  if (storedAreaId && storedDate === today) {
    return JSON.parse(storedAreaId);
  }

  try {
    const response = await get(`/api/region/manage/getActiveAreaId`, true);

    localStorage.setItem(ACTIVE_AREA_KEY, JSON.stringify(response));
    localStorage.setItem(ACTIVE_AREA_DATE_KEY, today);

    return response;
  } catch (error) {
    localStorage.removeItem(ACTIVE_AREA_KEY);
    localStorage.removeItem(ACTIVE_AREA_DATE_KEY);
    throw error;
  }
};
export const getUserInArea = (areaId, params = undefined) => {
  return get(
    `/api/region/manage_user/members/${areaId}?${params === undefined ? "" : params.toString()}`,
    true,
  );
};
export const getAreaCompleteInfo = (areaId) => {
  return get(`/api/region/manage/getAreaCompleteInfo/${areaId}`, true);
};
export const togglePatientReceptionStatus = (areaId) => {
  return put(`/api/region/manage/toggle-reception-status/${areaId}`, true);
};
export const getReceptionStatus = (areaId) => {
  return get(`/api/region/manage/get-reception-status/${areaId}`, true);
};
export const getAllModules = () => {
  return get(`/api/region/module/getAllModules`, true);
};
export const getModulesInArea = (areaId) => {
  return get(`/api/region/module/getModulesInArea/${areaId}`, true);
};
export const getgetDispatchers = (areaId) => {
  return get(`/api/region/manage_user/getDispatchers/${areaId}`, true);
};
export const getTrainers = (areaId) => {
  return get(`/api/region/manage_user/getTrainers/${areaId}`, true);
};
export const getInsurancers = (areaId) => {
  return get(`/api/region/manage_user/getInsurancers/${areaId}`, true);
};
export const getPharmacyManagers = (areaId) => {
  return get(`/api/region/manage_user/getPharmacyManagers/${areaId}`, true);
};
export const getEquipmentManagers = (areaId) => {
  return get(`/api/region/manage_user/getEquipmentManagers/${areaId}`, true);
};
export const getCoOrgs = () => {
  return get(`/api/public/getCoOrgs`, true);
};
export const getCountries = () => {
  return get(`/api/public/getCountries`, true);
};
export const getStates = (countryId) => {
  return get(`/api/public/getStates/${countryId}`, true);
};
export const getCities = (stateId) => {
  return get(`/api/public/getCities/${stateId}`, true);
};
export const getDashboardArea = (areaId) => {
  return get(`/api/region/manage/dashboard/${areaId}`, true);
};
export const getDrugListInArea = (areaId, query) => {
  return get(`/api/region/drug/list/${areaId}?${query.toString()}`, true);
};
export const getEquipmentListInArea = (areaId) => {
  return get(`/api/region/equipment/list/${areaId}`, true);
};
export const getNotificationsWithPagination = (pageIndex, pageSize, areaId) => {
  return get(
    `/api/notification/list/${areaId}?page=${pageIndex}&size=${pageSize}`,
    true,
  );
};

export const getUserNotificationsWithPagination = (
  pageIndex,
  pageSize,
  seenStatus,
) => {
  return get(
    `/api/notification/user-notifications?page=${pageIndex}&size=${pageSize}${seenStatus === undefined ? "" : "&seenStatus=" + seenStatus}`,
    true,
  );
};

export const getUserNotificationsCount = () => {
  return get(`/api/notification/user-notifications-count`, true);
};

export const setUserNotificationSeenStatus = (id) => {
  return post(`/api/notification/${id}/seen`, true);
};

export const getPatients = (areaId, query) => {
  return get(`/api/region/patient/getPatients/${areaId}?${query}`, true);
};
export const getPatientsExcelReport = (areaId, query) => {
  return get(
    `/api/region/patient/get-patients-excel-report/${areaId}?${query}`,
    true,
    {
      responseType: "blob",
    },
  );
};

export const getPresenceList = (areaId) => {
  return get(`/api/region/manage/getPresenceList/${areaId}`, true);
};
export const searchForDrugByName = (areaId, key) => {
  return get(`/api/region/drug/search/${areaId}?key=${key}`, true);
};
export const getDrugUseTimeOptions = () => {
  return get(`/api/public/getDrugUseTimeOptions`, true);
};
export const getDrugHowToUseOptions = () => {
  return get(`/api/public/getDrugHowToUseOptions`, true);
};
export const getAllDrugBookmark = (areaId) => {
  return get(`/api/jahadgar/drug/bookmarks/${areaId}`, true);
};
export const getDrugAmountOfUseOptions = () => {
  return get(`/api/public/getDrugAmountOfUseOptions`, true);
};
export const getTrainList = (areaId, filter) => {
  return get(
    `/api/region/patient/getTrainList/${areaId}${filter ? filter : ""}`,
    true,
  );
};
export const getExperimentInArea = () => {
  return get(`/api/region/experiment/list`, true);
};
export const getListOfAdvices = (areaId, filter) => {
  return get(`/api/jahadgar/drug/listOfAdvices/${areaId}?${filter}`, true);
};

export const getModulePatients = (areaId, moduleId, filter) => {
  return get(
    `/api/region/patient/getModulePatients/${areaId}/${moduleId}${
      filter ? filter : ""
    }`,
    true,
  );
};
export const getInsurerList = (areaId, filter) => {
  return get(
    `/api/region/patient/getInsuranceList/${areaId}${filter ? filter : ""}`,
    true,
  );
};
export const getPatientTrainFrom = (areaId, patientId) => {
  return get(
    `/api/region/patient/getPatientTrainFrom/${areaId}/${patientId}`,
    true,
  );
};

export const getHistoryTimeArea = (areaId) => {
  return get(`/api/region/manage/getRegionTimesHistory/${areaId}`, true);
};
export const getPatientReferrals = (areaId, patientId) => {
  return get(
    `/api/region/patient/getPatientReferrals/${areaId}/${patientId}`,
    true,
  );
};
export const getSubModuleInArea = (areaId, moduleId) => {
  return get(`/api/region/module/getModuleInArea/${areaId}/${moduleId}`, true);
};
export const getDrugsInArea = (areaId, pageIndex, pageSize) => {
  return get(
    `/api/drug/list/${areaId}?pageIndex=${pageIndex}&pageSize=${pageSize}`,
    true,
  );
};
export const getModuleNameInArea = (areaId) => {
  return get(`/api/region/module/getTabsInArea/${areaId}`, true);
};
export const getModulesInTab = (areaId, moduleName) => {
  return get(
    `api/region/module/getModulesInTab/${areaId}?tabName=${moduleName}`,
    true,
  );
};
export const getPatientForm = (areaId, moduleId, subModuleId, patientId) => {
  return get(
    `/api/region/patient/getPatientForm/${areaId}/${moduleId}/${subModuleId}/${patientId}`,
    true,
  );
};
export const getQuestionModule = (areaId, moduleId, subModuleId) => {
  return get(
    `/api/region/module/getSubModule/${areaId}/${moduleId}/${subModuleId}`,
    true,
  );
};
export const getRunInfoArea = (areaId) => {
  return get(`/api/region/manage/getRunInfo/${areaId}`, true);
};

export const getExperiments = (areaId, moduleId, patientId) => {
  return get(
    `/api/region/experiment/getExperiments/${areaId}/${moduleId}/${patientId}`,
    true,
  );
};
export const getAllExperimentsOfPatient = (areaId, patientId) => {
  return get(
    `/api/region/experiment/getAllExperimentsOfPatient/${areaId}/${patientId}`,
    true,
  );
};
export const putRunInfo = (areaId, data) => {
  return put(`/api/region/manage/setRunInfo/${areaId}`, true, data);
};
export const completeArea = (areaId, data) => {
  return put(`/api/region/manage/completeArea/${areaId}`, true, data);
};
export const setPatientTrainFrom = (areaId, patientId, data) => {
  return put(
    `/api/region/patient/setPatientTrainFrom/${areaId}/${patientId}`,
    true,
    data,
  );
};
export const putAddDispatcher = (areaId, data) => {
  return put(`/api/region/manage_user/addDispatcher/${areaId}`, true, data);
};
export const putAddReferralForPatientByOwner = (
  areaId,
  moduleId,
  patientId,
) => {
  return put(
    `/api/region/patient/addReferralForPatientByOwner/${areaId}/${patientId}/${moduleId}`,
    true,
  );
};
export const putAddReferralForPatient = (
  areaId,
  srcModuleId,
  moduleId,
  patientId,
) => {
  return put(
    `/api/region/patient/addReferralForPatient/${areaId}/${srcModuleId}/${moduleId}/${patientId}`,
    true,
  );
};
export const addReferralForPatientByTrainer = (
  areaId,
  destModuleId,
  patientId,
) => {
  return put(
    `/api/region/patient/addReferralForPatientByTrainer/${areaId}/${destModuleId}/${patientId}`,
    true,
  );
};

export const putAddMujahidArea = (areaId, data) => {
  return put(`/api/region/manage_user/addMembers/${areaId}`, true, data);
};
export const putAddModuleArea = (areaId, data) => {
  return put(`/api/region/module/setModules/${areaId}`, true, data);
};
export const putSubmitEntrance = (userId, areaId) => {
  return put(`/api/region/manage/submitEntrance/${userId}/${areaId}`, true);
};
export const putFinalize = (areaId) => {
  return put(`/api/region/manage/finalize/${areaId}`, true);
};
export const putStartRegionTime = (areaId) => {
  return put(`/api/region/manage/setStartRegionTime/${areaId}`, true);
};
export const putEndRegionTime = (areaId) => {
  return put(`/api/region/manage/setEndRegionTime/${areaId}`, true);
};
export const bookmarkDrug = (drugId, data) => {
  return put(`/api/jahadgar/drug/bookmark/${drugId}`, true, data);
};
export const putAddPatient = (areaId, data) => {
  return put(
    `/api/region/patient/createPatientAndAddToRegion/${areaId}`,
    true,
    data,
  );
};
export const putAddUesersModule = (areaId, moduleIdInArea, data) => {
  return put(
    `/api/region/module/setMembersToModule/${areaId}/${moduleIdInArea}`,
    true,
    data,
  );
};
// export const putReceptionStatusOfPatient = (areaId, moduleIdInArea, data) => {
//   return put(
//     `/api/region/patient/setReceptionStatusOfPatient/${areaId}/${moduleId}/${patientId}`,
//     true,
//     data
//   );
// };
export const setPatientTrainStatus = (areaId, patientId, hasTrained) => {
  return put(
    `/api/region/patient/setPatientTrainStatus/${areaId}/${patientId}?hasTrained=${hasTrained}`,
    true,
  );
};
export const setPatientInsuranceStatus = (areaId, patientId, filter) => {
  return put(
    `/api/region/patient/setPatientInsuranceStatus/${areaId}/${patientId}${
      filter ? filter : ""
    }`,
    true,
  );
};
export const putAddSecretariesModule = (areaId, moduleIdInArea, data) => {
  return put(
    `/api/region/module/addSecretariesToModule/${areaId}/${moduleIdInArea}`,
    true,
    data,
  );
};
export const putUpdatePresenceList = (userId, areaId, presenceListId, data) => {
  return put(
    `/api/region/manage/updatePresenceList/${userId}/${areaId}?${presenceListId !== undefined ? "presenceListId=" + presenceListId : ""}`,
    true,
    data,
  );
};
export const putAddTrainer = (areaId, data) => {
  return put(`/api/region/manage_user/addTrainer/${areaId}`, true, data);
};
export const giveDrugToPatient = (areaId, adviceId, data) => {
  return put(
    `/api/jahadgar/drug/giveDrugToPatient/${areaId}/${adviceId}`,
    true,
    data,
  );
};
export const putAddDrugInArea = (areaId, data) => {
  return put(`/api/jahadgar/drug/addAllToDrugsList/${areaId}`, true, data);
};
export const putAddEquipmentInArea = (areaId, data) => {
  return put(
    `/api/jahadgar/equipment/addAllEquipmentsToArea/${areaId}`,
    true,
    data,
  );
};
export const putAddInsurancer = (areaId, data) => {
  return put(`/api/region/manage_user/addInsurancer/${areaId}`, true, data);
};
export const addPharmacyManager = (areaId, data) => {
  return put(
    `/api/region/manage_user/addPharmacyManager/${areaId}`,
    true,
    data,
  );
};
export const addEquipmentManager = (areaId, data) => {
  return put(
    `/api/region/manage_user/addEquipmentManager/${areaId}`,
    true,
    data,
  );
};
export const returnAllDrugs = (areaId) => {
  return put(`/api/region/drug/returnAllDrugs/${areaId}`, true);
};
export const returnAllEquipments = (areaId) => {
  return put(`/api/region/equipment/returnAllEquipments/${areaId}`, true);
};

export const addReferralForPatient = (areaId, moduleId, patientId, data) => {
  return put(
    `/api/region/patient/addReferralForPatient/${areaId}/${moduleId}/${patientId}`,
    true,
    data,
  );
};
export const notificationStore = (areaId, data) => {
  return post(`/api/notification/${areaId}`, true, data);
};
export const notificationUpdate = (id, data) => {
  return put(`/api/notification/${id}`, true, data);
};
export const notificationDelete = (id) => {
  return delete_(`/api/notification/${id}`, true);
};
export const sendTripAlarmToAllMembers = (areaId, data) => {
  return post(
    `/api/region/manage/sendTripAlarmToAllMembers/${areaId}`,
    true,
    data,
  );
};
export const setReceptionStatusOfPatient = (
  areaId,
  moduleId,
  patientId,
  isRecepted,
) => {
  return put(
    `/api/region/patient/setReceptionStatusOfPatient/${areaId}/${moduleId}/${patientId}?isRecepted=${isRecepted}
    `,
    true,
  );
};
export const getReceptionStatusOfPatient = (areaId, moduleId, patientId) => {
  return get(
    `/api/region/patient/getReceptionStatusOfPatient/${areaId}/${moduleId}/${patientId}`,
    true,
  );
};
export const addReferralForPatientBySubModule = (
  areaId,
  moduleId,
  subModuleId,
  patientId,
) => {
  return put(
    `/api/region/patient/addReferralForPatientBySubModule/${areaId}/${moduleId}/${subModuleId}/${patientId}
    `,
    true,
  );
};
export const setPatientForm = (
  areaId,
  moduleId,
  subModuleId,
  patientId,
  data,
  body,
) => {
  return put(
    `/api/region/patient/setPatientForm/${areaId}/${moduleId}/${subModuleId}/${patientId}?forms=${data}
    `,
    true,
    body,
    // {
    //   "content-type": "multipart/form-data",
    //   "Access-Control-Allow-Origin": "*/*",
    // }
  );
};
export const inquiryPatient = (areaId, data) => {
  return post(`/api/region/patient/inquiryPatient/${areaId}`, true, data);
};
export const suggestExperiment = (areaId, moduleId, patientId, data) => {
  return post(
    `/api/region/experiment/suggestExperiment/${areaId}/${moduleId}/${patientId}`,
    true,
    data,
  );
};
export const postAdvice = (patientId, moduleId, areaDrugId, data) => {
  return post(
    `/api/jahadgar/drug/advice/${patientId}/${moduleId}/${areaDrugId}`,
    true,
    data,
  );
};
export const postAdvice1 = (patientId, areaDrugId, data) => {
  return post(
    `/api/jahadgar/drug/advice/${patientId}/${areaDrugId}`,
    true,
    data,
  );
};
export const addPatientToRegion2 = (areaId, patientId) => {
  return put(
    `/api/region/patient/addPatientToRegion/${areaId}/${patientId}`,
    true,
  );
};
export const _deleteUserFromArea = (areaId, userId) => {
  return delete_(
    `/api/region/manage_user/removeMember/${areaId}/${userId}`,
    true,
  );
};
export const removeTrainer = (areaId, userId) => {
  return delete_(
    `/api/region/manage_user/removeTrainer/${areaId}/${userId}`,
    true,
  );
};
export const removeDispatcher = (areaId, userId) => {
  return delete_(
    `/api/region/manage_user/removeDispatcher/${areaId}/${userId}`,
    true,
  );
};
export const removeInsurancer = (areaId, userId) => {
  return delete_(
    `/api/region/manage_user/removeInsurancer/${areaId}/${userId}`,
    true,
  );
};
export const removePharmacyManager = (areaId, userId) => {
  return delete_(
    `/api/region/manage_user/removePharmacyManager/${areaId}/${userId}`,
    true,
  );
};
export const removeEquipmentManager = (areaId, userId) => {
  return delete_(
    `/api/region/manage_user/removeEquipmentManager/${areaId}/${userId}`,
    true,
  );
};
export const removeExperiment = (areaId, moduleId, patientId, experimentId) => {
  return delete_(
    `/api/region/experiment/removeExperiment/${areaId}/${moduleId}/${patientId}/${experimentId}`,
    true,
  );
};

export const removeAdvice = (adviceId) => {
  return delete_(`/api/jahadgar/drug/removeAdvice/${adviceId}`, true);
};
export const removeDrugInBookmark = (drugId) => {
  return delete_(`/api/jahadgar/drug/bookmark/${drugId}`, true);
};
